/* eslint-disable */

<template>
	<div class="product-detail">
		<div class="app-wrapper">
			<div class="wrapper-section-description"
				v-if="tabs.length === 1">
				<h4 class="title">{{product.title}}</h4>
				<div v-html="product.description" class="description"></div>
				<div
					v-if="product.files.length"
					class="wrapper-buttons">
					<template v-for="(btn, index) in product.files">
						<a class="btn-tab"
							:key="index"
							download
							target="_blank"
							v-if="btn.path"
							:href="btn.path">
							{{btn.text}}
							<simple-svg
								class="download-tab"
								:filepath="'/static/img/detail-download.svg'"
								:fill="'#002c55'"
								width="16"
							/>
						</a>
					</template>
				</div>
			</div>
			<div 
				v-else
				class="wrapper-tabs-products">
				<div class="product-tabs">
					<ul class="wrapper-tabs">
						<li 
							v-for="(item, index) in tabs" 
							:key="index">		
							<button 
								class="tab-btn"
								@click="slideTo(index)"
							>
								<span 
									class="tab-text"
									:class="{active : currentSlider === index}">{{item.title}}</span>
								<div 
									class="wrapper-circle"
									:class="{active : currentSlider === index}">
									<div 
										class="circle"
										:class="{active: currentSlider === index}"></div>
								</div>
							</button>
						</li>
					</ul>
					<hr class="line-tab">
					<select class="form-input tabs--select" v-model="currentTab" @change="triggerSlideTo">
						<option
							v-for="(item, index) in tabs"
							:key="`tab-option-${index}`"
							:value="index">{{item.title}}</option>
					</select>
				</div>
				<div class="width-slider-mobile">
					<h4 class="title">{{product.title}}</h4>
					<slider
						:options="options"
						class="slider--product"
						ref="slider-parent">
						<slideritem 
							v-for="(item, index) in tabs" 
							:key="index">
							<div
								v-html="item.description"
								class="slider-text"></div>
							<ul class="list-slider">
								<li 
									v-for="(itemList, indexList) in item.list"
									:key="indexList">{{itemList}}</li>
							</ul>
						</slideritem>
					</slider>
				</div>
				<div class="wrapper-buttons">
					<template v-for="(btn, index) in product.files">
						<span :key="index" v-if="whiteSpace(btn.path) !== ''"
							:v-show="true">
							
						<a class="btn-tab"
							:key="index"
							download
							target="_blank"
							v-if="btn.path !== ''"
							:href="btn.path"
							>
							{{btn.text}}
							<simple-svg
								class="download-tab"
								:filepath="'/static/img/detail-download.svg'"
								:fill="'#002c55'"
								width="16"
							/>
						</a>
						</span>
					</template>
				</div>
			</div>
			<div class="slider__images">
				<slider
					:options="sliderOptionsImages"
					class="slider__images__wrapper"
					ref="slider-images">
					<slideritem 
						v-for="(image, index) in productImages" 
						:key="`product-image-${index}`">
						<figure class="slider__images__figure">
							<img
								:src="image"
								:alt="product.title" />
						</figure>
					</slideritem>
				</slider>
				<div
					v-if="productImages.length > 1"
					class="slider__images__thumbs">
					<button
						@click="sliderImagesSlideTo(index)"
						v-for="(image, index) in productImages" 
						:key="`product-image-thumb-${index}`">
						<figure :class="{
							'slider__images__thumbs__figure': true,
							'slider__images__thumbs__figure--active': sliderImagesCurrentIndex === index,
						}">
							<img
								:src="image"
								:alt="product.title" />
						</figure>
					</button>
				</div>
			</div>
			<!-- <div v-if="product.dataImage" class="container-video top-detail">
				<div class="app-tab-slider">
					<div 
						v-for="(img, index) in product.dataImage.data" 
						:key="index">
						<img :src="img.source" alt="" class="video-desktop img-principal">
					</div>
				</div>
				<div class="products-tab-thumbnails">
					<div 
						v-for="(img, index) in product.dataImage.data" 
						:key="index" class="wrapper-image-thumbnails">
						<img :src="img.source" alt="" class="video-desktop-thum">
					</div>
				</div>
			</div>
			<div v-else class="container-video top-detail">
				<img 
					:src="product.imagePrevious" 
					alt="image-producto" 
					class="video-desktop img-principal" />
			</div> -->
		</div>
		<div class="line"></div>	
	</div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider';

const components = {
	slider,
	slideritem,
};

const computed = {
	productImages() {
		let images = [this.product.imagePrevious];
		if (this.product.dataImage) {
			images = [
				...images,
				...this.product.dataImage.data.map(i => i.source),
			];
		}
		return images;
	},
};

const methods = {
	sliderImagesSlideTo(slide) {
		this.$refs['slider-images'].$emit('slideTo', slide);
		this.sliderImagesCurrentIndex = slide;
	},
	slideTo(index) {
		this.$refs['slider-parent'].$emit('slideTo', index);
		this.currentSlider = index;
	},
	triggerSlideTo() {
		this.slideTo(this.currentTab);
	},
	whiteSpace(a) {
		console.log(a);
		let str = a;
		if (str!==null){
			str.trim();
			console.log(str);
		} else {
			str = '';
		}
		return str;
	},
};

const props = {
	product: {
		type: Object,
		default: () => {},
	},
};

const watch = {
	product() {
		const description = {
			title: this.product.title,
			description: this.product.description,
		};

		this.tabs.push(description);

		if (this.product.properties.description) {
			this.tabs.push(this.product.properties);
		}

		if (this.product.features.description) {
			this.tabs.push(this.product.features);
		}
	},
};

function data() {
	return {
		tabs: [],
		options: {
			currentPage: 0,
			speed: 500,
			pagination: false,
			freeze: true,
		},
		sliderOptionsImages: {
			currentPage: 0,
			speed: 500,
			pagination: false,
			freeze: true,
		},
		currentTab: 0,
		currentSlider: 0,
		sliderImagesCurrentIndex: 0,
	};
}

function mounted() {
	const description = {
		title: this.product.title,
		description: this.product.description,
	};

	this.tabs.push(description);

	if (this.product.properties.description) {
		this.tabs.push(this.product.properties);
	}

	if (this.product.features.description) {
		this.tabs.push(this.product.features);
	}
}

export default {
	components,
	computed,
	data,
	methods,
	mounted,
	name: 'detail-product',
	props,
	watch,
};
</script>


<style lang="scss">
.slider {
	&__images {
		flex: 1;
		max-width: 500px;
		position: relative;
		margin-left: 20px;

		&__thumbs {
			@include display-flex();
			flex-direction: column;
			position: absolute;
			top: 3px;
			right: -70px;
			z-index: 10;

			&__figure {
				@include transition(border-color .3s linear 0s);
				border: 2px solid transparent;

				img {
					display: block;
					max-width: 55px;
				}

				&--active {
					border: 2px solid #5dc980;
				}
			}
		}

		&__figure {
			max-width: 500px;

			img {
				display: block;
				margin: 0 auto;
				max-height: 500px;
				max-width: 100%;
			}
		}
	}
}

	.product-detail {
		background: map-get($colors, background-products);
		position: relative;
		padding: 80px 0;
		
		.app-wrapper {
			@include display-flex();
			align-items: flex-start;
			justify-content: space-between;
		}

		.title {
			@include font-maison-bold;
			@include font-size(32);
			color: map-get($colors, black-dark);
			margin-bottom: 30px;
			text-align: left;
		}

		.description {
			@include font-size(15);
			color: map-get($colors, text);
			line-height: 25px;
			text-align: justify;
		}

		.tns-outer {
			width: 78%;
		}

		.slider-item {
			display: block;
		}
		
		.width-slider-mobile {
			.title {
				margin: 50px 25px 20px;
			}
		}
	}

	.wrapper-buttons {
		@include display-flex;
		margin-bottom: 100px;
		margin-top: 30px;
	}

	.btn-tab {
		@include font-maison-medium;
		@include flex-center;
		@include border-radius(3px);
		@include font-size(13);
		border: 1px solid map-get($colors, black-dark);
		color: map-get($colors, black-dark);
		margin-right: 11px;
		padding: 8px 12px;
	}

	.download-tab {
		height: 16px;
		margin-left: 10px;
	}

	.container-video {
		@include display-flex();
		flex: 1;
		justify-content: flex-end;
		align-items: flex-start;
		overflow: hidden;
		position: relative;
	}

	.products-tab-thumbnails {
		@include display-flex();
		flex-direction: column;

		.container-video {
			border: 2px solid transparent;
			cursor: pointer;
			height: 70px;
			margin: 0 12px;
			outline: none;
			width: 70px;
		}

		.tns-nav-active {
			border: 2px solid map-get($colors, black-dark);
			outline: none;
		}
	}

	.video-desktop {
		max-height: 600px;
	}

	.wrapper-section-description {
		padding: 0 25px 60px;
		width: 55%;

		.description {
			ul {
				list-style: circle;
				margin: 0 20px;
			}
		} 
	}

	.line {
		background: map-get($colors, black-dark);
		bottom: 0;
		height: 11px;
		left: 0;
		position: absolute;
		width: 100%;
	}

	.video-desktop-thum {
		height: 63px;
		width: auto;
	}

	.tab-text {
		@include transform(translateX(-50%));
		@include font-maison-light();
		@include font-size(14);
		margin-bottom: 17px;
		color: map-get($colors, grey-text);
		position: absolute;
		bottom: 10px;
		min-width: 192px;
		left: 50%;

		&.active {
			@include font-size(16);
			@include font-maison-bold();
			color: map-get($colors, green-tab);
		}
	}

	.list-slider {
		@include font-size(15);
		color: map-get($colors, text);
		list-style: circle;
		margin-left: 21px;
		text-align: left;
	}

	.wrapper-tabs-products {
		max-width: 500px;
	}

	@media screen and (max-width: 1025px) {
		.app-background-white {
			display: none;
		}

		.product-detail {
			flex-direction: column;
			padding: 69px 30px;

			.title {
				@include font-size(20);
				text-align: center;
			}

			.tns-outer {
				width: auto;
			}

			.slider-item {
				padding: 0 40px;
			}
		}

		.wrapper-section-description {
			padding: 0px;
			width: 100%;
		}

		.container-video {
			flex-direction: column;
			width: 100%;
		}

		.products-tab-thumbnails {
			flex-direction: row;
			justify-content: center;
		}

		.wrapper-buttons {
			align-items: center;
			flex-direction: column;
			margin-bottom: 50px;
		}

		.btn-tab {
			margin-bottom: 16px;
			width: 171px;
		}

		.img-principal {
			@include transform(translateX(-50%));
			left: 50%;
			max-height: 392px;
			position: relative;
			width: auto;
		}

		.product-tabs {
			min-width: auto !important;
			width: 100%;
		}

		.width-slider-mobile {
			margin: auto;
			width: 100%;
		}
	}

	.wrapper-circle {
		@include flex-center();
		@include border-radius(50%);
		@include transition();
		height: 23px;
		width: 23px;

		.circle {
			@include border-radius(50%);
			background: map-get($colors, white-dark);
			height: 12px;
			width: 12px;

			&.active {
				background: map-get($colors, green-tab);
			}
		}
	}

	.wrapper-tabs {
		@include display-flex();
		justify-content: space-between;
		position: relative;
		z-index: 9;
		
		> li {
			margin-bottom: -18px;
		}
	}

	.tab-btn {
		@include flex-center();
		flex-direction: column;
		position: relative;
	}

	.slider--product {
		.slider-wrapper {
			align-items: flex-start !important;
		}

		.slider-item {
			align-items: flex-start !important;
		}
	}
	

	.slider-text {
		color: map-get($colors, text);
		font-size: 15px;
		padding: 0 35px 0 25px;
		text-align: left;
		
		ul {
			list-style: circle;
			margin: 0 20px;
		}
	}

	.product-tabs {
		margin: 25px 15px 0;
		position: relative;
	}

	.line-tab {
		@include transform(translate(-50%, -50%));
		@include opacity(.4);
		left: 50%;
		position: absolute;
		top: 69%;
		width: 76%;
		z-index: 6;

		@media (min-width: 964px) {
			width: 90%;
		}
	}

.tabs--select {
	display: none;
}

@media screen and (max-width: 600px) {
	.product-detail {
		padding: 20px 0 60px;

		.app-wrapper {
			flex-direction: column;
			width: 96%;
		}
	}

	.wrapper-tabs-products {
		flex: 1;
		max-width: 100%;
	}

	.product-tabs {
		margin: 20px auto;
		width: 96%;

		.tab-text {
			@include font-size(14);
		}
	}

	.product-detail {
		.width-slider-mobile {
			.title {
				margin: 40px 20px 20px;
				text-align: left;
			}
		}

		.slider-item {
			padding: 0 20px;
		}
	}

	.slider-text {
		padding: 0;
	}

	.wrapper-tabs {
		display: none;
	}

	.line-tab {
		display: none;
	}

	.tabs--select {
		display: block;
	}

	.slider {
		&__images {
			margin-left: 0;
			width: 100%;
			
			&__thumbs {
				background-color: rgba($black, .5);
				right: 20px;
				top: 0;
				padding: 4px 0;

				&__figure {
					img {
						max-width: 60px;
					}
				}
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/product/detail.vue